import HeroSection from "../components/HeroSection";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Contact from "../components/Contact";
import Experience from "../components/Experience";
import Education from "../components/Education";
import Seo from "../components/Seo";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100%;
  background: linear-gradient(180deg, rgba(109, 40, 217, 0.045) 0%, rgba(255, 255, 255, 0) 100%);
`;

const Home = ({ openModal, setOpenModal }) => {
  return (
    <main>
      <Seo
        title="Saroj Giri | Full Stack Developer in Nepal"
        description="Saroj Giri (Sawroz) is an ICT graduate and full-stack developer from Damauli, Nepal. Explore web apps, Android work, computer-vision projects, and ways to get in touch."
        path="/"
      />
      <HeroSection />
      <Wrapper>
        <Skills />
        <Experience />
      </Wrapper>
      <Projects openModal={openModal} setOpenModal={setOpenModal} />
      <Wrapper>
        <Education />
        <Contact />
      </Wrapper>
    </main>
  );
};

export default Home;
